<template>
  <div>
    <h3 class="categ-title">{{ category.name }} ({{ category.commands.length }})</h3>
    <CommandCard v-for="(command, i) in category.commands" v-bind:key="command.name" v-bind:command="command" :style="`animation-delay: ${(cIndex*(previousLength)*0.2)+i*0.2}s`"/>
  </div>
</template>

<script>
import CommandCard from "@/components/CommandCard.vue";

export default {
  name: "CommandCategory",
  components: {
    CommandCard
  },
  props: ["category", "cIndex", "previousLength"],
  ready() {
    console.log(this.category);
  }
}
</script>

<style scoped>
  .categ-title {
    font-size: 22px;
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .categ-first {
    margin-top: 0.1em!important;
  }
</style>